query allHockeyPlayers(
  $first: Int
  $offset: Int
  $filter: HockeyPlayerWithTeamFilter
  $condition: HockeyPlayerWithTeamCondition
) {
  players: allHockeyPlayerWithTeams(
    first: $first
    offset: $offset
    filter: $filter
    condition: $condition
  ) {
    nodes {
      teams
      player {
        name
        source
        playerIndex
        position
        playerId
      }
    }
    totalCount
  }
}
